import useFetch from '@hooks/useFetch';
import { getIsLoggedIn } from '@api/selectors/auth';
import useMyInfo from '../auth/useMyInfo';

const useCashPaymentStatus = (goalUID) => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const { data: cashResponse, ...rest } = useFetch(
    goalUID && isLoggedIn
      ? `v1/subscriptions/cash_payment_subscription_details/?goal_uid=${goalUID}`
      : null
  );

  return { cashResponse, ...rest };
};

export default useCashPaymentStatus;
